import { useState } from "react";
import { applicationStatusDoumentTypeMap } from "../../../config/applicationStatusConfig";
import { Spinner } from "../../../icons/CommonIcons";
import Button from "../../common/Button";
import { schemeTypes } from "../../../config/appliedSchemesConfig";
import { scriptRegex } from "../../../utils/utils";

const AssignOfficerCard = ({
  formData,
  onAssign,
  status,
  incentiveClaimId,
  installmentType,
}) => {
  const [selectedOfficer, setSelectedOfficer] = useState("");
  const [remarks, setRemarks] = useState("");
  const [updating, setUpdating] = useState(false);
  const [isAssigningToDDO, setIsAssigningToDDO] = useState(false);
  const [file, setFile] = useState(null);

  const options = [];

  const isCapitalScheme =
    String(incentiveClaimId) ===
    schemeTypes.sreimbursementcapitalincentive.value;

  const isInterestScheme =
    String(incentiveClaimId) === schemeTypes.interestassistance.value;

  const interestInstallmentMap = {
    1: {
      tifc: "tifc_verified_report_interest_assistance_first_installment",
      slac: "slac_approved_report_interest_assistance_first_installment",
    },
    2: {
      tifc: "tifc_verified_report_interest_assistance_second_installment",
      slac: "slac_approved_report_interest_assistance_second_installment",
    },
    3: {
      tifc: "tifc_verified_report_interest_assistance_third_installment",
      slac: "slac_approved_report_interest_assistance_third_installment",
    },
  };

  if (isCapitalScheme) {
    if (!formData.tifc_verified_report_capital_subsidy?.url) {
      options.push({ value: "TIFC", label: "Assign to TIFC" });
    }
    if (
      formData.tifc_verified_report_capital_subsidy?.url &&
      !formData.dlct_verified_report_capital_subsidy?.url &&
      !formData.dlct_unverified_report_capital_subsidy?.url
    ) {
      options.push({ value: "TIFC", label: "Assign to TIFC" });
      options.push({
        value: "DLCT",
        label: "Assign to DLCT for Physical Inspection",
      });
    }
    // Step 3: DLCT done → allow SLAC
    else if (
      formData.tifc_verified_report_capital_subsidy?.url &&
      (formData.dlct_verified_report_capital_subsidy?.url ||
        formData.dlct_verified_report_capital_subsidy?.url) &&
      !formData.slac_approved_report_capital_subsidy?.url
    ) {
      options.push({ value: "TIFC", label: "Assign to TIFC" });
      options.push({
        value: "DLCT",
        label: "Assign to DLCT for Physical Inspection",
      });
      options.push({
        value: "SLAC",
        label: formData.dlct_verified_report_capital_subsidy?.url
          ? "Forward to SLAC for Approval"
          : "Forward to SLAC",
      });
    } else if (
      formData.tifc_verified_report_capital_subsidy?.url &&
      (formData.dlct_verified_report_capital_subsidy?.url ||
        formData.dlct_verified_report_capital_subsidy?.url) &&
      formData.slac_approved_report_capital_subsidy?.url
    ) {
      options.push({ value: "TIFC", label: "Assign to TIFC" });
      options.push({
        value: "DLCT",
        label: "Assign to DLCT for Physical Inspection",
      });
      options.push({ value: "SLAC", label: "Forward to SLAC for Approval" });
      options.push({
        value: "DDO",
        label: "Assign To Finance for Disbursal of Payment",
      });
    }
    // Step 4: SLAC uploaded → auto → no option, handled by backend
    else {
      //return null;
    }
  } else if (isInterestScheme && installmentType) {
    const installmentConfig = interestInstallmentMap[parseInt(installmentType)];

    if (!installmentConfig) return null;

    const { tifc, slac } = installmentConfig;

    const tifcDone = !!formData[tifc]?.url;
    const slacDone = !!formData[slac]?.url;

    // Step 1: Before TIFC
    if (!tifcDone) {
      options.push({ value: "TIFC", label: "Assign to TIFC" });
    }

    // Step 2: TIFC done → SLAC
    else if (tifcDone && !slacDone) {
      options.push({ value: "TIFC", label: "Assign to TIFC" });
      options.push({
        value: "SLAC",
        label: "Forward to SLAC for Approval",
      });
    }

    // Step 3: SLAC done → DDO
    else if (tifcDone && slacDone) {
      options.push({ value: "TIFC", label: "Assign to TIFC" });
      options.push({
        value: "SLAC",
        label: "Forward to SLAC for Approval",
      });
      options.push({
        value: "DDO",
        label: "Assign To Finance for Disbursal of Payment",
      });
    }
    // Step 4: SLAC uploaded → auto → no option, handled by backend
    else {
      //return null;
    }
  }

  // Assign back to user for specific statuses

  // if (
  //   [
  //     applicationStatusDoumentTypeMap.incompleteDocumentPending.value,
  //     applicationStatusDoumentTypeMap.incompleteInformation.value,
  //     applicationStatusDoumentTypeMap.dlctUnverified.value,
  //   ].includes(String(status))
  // ) {
  options.push({
    value: "USER",
    label: "Assign to User",
  });
  //}

  const handleAssign = async () => {
    if (selectedOfficer) {
      try {
        setUpdating(true);
        await onAssign(selectedOfficer, remarks, file);
      } catch (err) {
      } finally {
        setUpdating(false);
      }
    }
  };

  return (
    <div className="space-y-4">
      <label className="block font-medium text-gray-700">
        Assign Application To:
      </label>
      <select
        className="w-full border rounded px-3 py-2"
        value={selectedOfficer}
        onChange={(e) => {
          setSelectedOfficer(e.target.value);
          setIsAssigningToDDO(e.target.value === "DDO");
        }}
      >
        <option value="">Select Officer</option>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
      <div>
        <label htmlFor="remarks" className="block font-medium text-gray-700">
          Remarks
        </label>
        <textarea
          id="remarks"
          value={remarks}
          onChange={(e) => {
            if (!scriptRegex.test(e.target.value)) {
              setRemarks(e.target.value);
            }
          }}
          className="mt-1 block w-full border border-gray-300 rounded px-3 py-2 text-sm"
        ></textarea>
      </div>
      {isAssigningToDDO && (
        <div>
          <label className="block font-medium text-gray-700 mb-1">
            Upload Sanction Order File
            <span className="text-red-600">*</span>
          </label>

          <div className="flex flex-col items-start">
            {/* Styled button */}
            <label
              htmlFor="upload-file"
              className="cursor-pointer inline-flex items-center justify-center px-5 py-2 bg-btn text-white text-sm font-medium rounded-md shadow hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-btn w-auto min-w-40"
            >
              📂 Choose File
            </label>
            <input
              id="upload-file"
              type="file"
              className="hidden"
              onChange={(e) => setFile(e.target.files[0])}
            />

            {/* Show chosen file name */}
            {file && (
              <p className="mt-2 text-sm text-gray-600 truncate">{file.name}</p>
            )}
          </div>
        </div>
      )}
      {updating ? (
        <Button className="px-4 py-2 rounded bg-btn text-white flex items-center justify-center gap-2">
          Updating
          <Spinner />
        </Button>
      ) : (
        <button
          onClick={handleAssign}
          disabled={!selectedOfficer || (isAssigningToDDO && !file)}
          className={`px-4 py-2 rounded ${
            selectedOfficer && (!isAssigningToDDO || file)
              ? "bg-btn text-white"
              : "bg-gray-300 text-gray-600 cursor-not-allowed"
          }`}
        >
          Forward
        </button>
      )}
    </div>
  );
};

export default AssignOfficerCard;
